import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase';

const NAV_LINKS = [
  { label: 'Features',      href: '#features' },
  { label: 'Sell',         href: '/createpremiummessage' },
  { label: 'Post',         href: '/postonpremsi' },
  { label: 'For Creators', href: '/invitation' },
  { label: 'FAQ',          href: '/faq' },
];

export default function AltNav() {
  const [menuOpen, setMenuOpen]   = useState(false);
  const [scrolled, setScrolled]   = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!auth.currentUser);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return unsub;
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* overflow-x: hidden on html/body breaks position: sticky — clip instead */
  useEffect(() => {
    const targets = [
      document.documentElement,
      document.body,
      document.querySelector('.app'),
    ].filter(Boolean);
    const prev = targets.map((el) => el.style.overflowX);
    targets.forEach((el) => { el.style.overflowX = 'clip'; });
    return () => {
      targets.forEach((el, i) => { el.style.overflowX = prev[i]; });
    };
  }, []);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 850) setMenuOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Prevent body scroll while mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <header className={`alt-nav${scrolled ? ' alt-nav--scrolled alt-nav--pinned' : ''}${menuOpen ? ' alt-nav--menu-open' : ''}`}>
      <div className="alt-nav__inner alt-container">

        {/* Brand wordmark */}
        <a href="/" className="alt-nav__brand" aria-label="Premsi home">
          <img
            loading="lazy"
            src={require('../../images/pblue-min.webp')}
            alt="Premsi logo"
            className="alt-nav__brand-icon"
          />
          PREMSI
        </a>

        {/* Centre links — desktop only */}
        <nav className="alt-nav__links" aria-label="Primary">
          {NAV_LINKS.map(({ label, href }) => (
            <a key={label} href={href} className="alt-nav__link">
              {label}
            </a>
          ))}
        </nav>

        {/* Right actions — desktop only */}
        <div className="alt-nav__actions">
          {isLoggedIn ? (
            <>
              <a href="/alternativehomepage" className="alt-nav__login">Feed</a>
              <a href="/profile" className="alt-nav__cta">Account</a>
            </>
          ) : (
            <>
              <a href="/alternativehomepage" className="alt-nav__login">Log in</a>
              <a href="/invitation" className="alt-nav__cta">Get started</a>
            </>
          )}
        </div>

        {/* Hamburger — mobile only */}
        <button
          type="button"
          className="alt-nav__burger"
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="alt-nav-mobile"
        >
          <span className={`alt-nav__burger-bars${menuOpen ? ' alt-nav__burger-bars--open' : ''}`} />
        </button>
      </div>

      {/* Mobile overlay menu */}
      <div
        id="alt-nav-mobile"
        className={`alt-nav__mobile${menuOpen ? ' alt-nav__mobile--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <nav className="alt-nav__mobile-links" aria-label="Mobile primary">
          {NAV_LINKS.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              className="alt-nav__mobile-link"
              onClick={() => setMenuOpen(false)}
            >
              {label} &rarr;
            </a>
          ))}
        </nav>
        <div className="alt-nav__mobile-actions">
          {isLoggedIn ? (
            <>
              <a href="/alternativehomepage" className="alt-nav__mobile-login" onClick={() => setMenuOpen(false)}>
                Feed
              </a>
              <a href="/profile" className="alt-nav__mobile-cta" onClick={() => setMenuOpen(false)}>
                Account
              </a>
            </>
          ) : (
            <>
              <a href="/alternativehomepage" className="alt-nav__mobile-login" onClick={() => setMenuOpen(false)}>
                Log in
              </a>
              <a href="/invitation" className="alt-nav__mobile-cta" onClick={() => setMenuOpen(false)}>
                Get started
              </a>
            </>
          )}
        </div>
      </div>
    </header>
    {scrolled && <div className="alt-nav__spacer" aria-hidden="true" />}
    </>
  );
}
